import React from 'react';
import { useLanguage } from '../../../i18n/LanguageContext';

const ProductSearchBar = React.memo(({ 
  searchQuery, 
  setSearchQuery, 
  filteredProductsCount, 
  isAdmin, 
  isSatisci, 
  isMontajci, 
  handleAddNew 
}) => {
  const { t } = useLanguage();

  return (
    <div className="product-search-bar">
      <div className="product-search-input-wrapper">
        <i className="fas fa-search product-search-icon"></i>
        <input
          type="text"
          className="product-search-input"
          placeholder={t('productList.searchPlaceholder', 'Ürün adıyla ara...')}
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
        {searchQuery && (
          <button
            className="product-search-clear"
            onClick={() => setSearchQuery('')}
            title={t('productList.clearSearch', 'Aramayı temizle')}
          >
            <i className="fas fa-times"></i>
          </button>
        )}
      </div>
      {searchQuery && (
        <span className="product-search-result-count">
          {filteredProductsCount} {t('productList.resultsCount', 'sonuç')}
        </span>
      )}

      <div className="product-search-actions">
        {(isAdmin || isSatisci) && !isMontajci && (
          <button className="btn-add-product" onClick={handleAddNew}>
            <i className="fas fa-plus"></i> {t('productList.addNewProduct', 'Yeni Ürün Ekle')}
          </button>
        )}
      </div>
    </div>
  );
});

export default ProductSearchBar;
